import React from "react"
import { Row, Col, Panel, Image, Glyphicon, Button } from "react-bootstrap"

class ImageThumbnailsDownload extends React.Component {

    dataURLtoBlob = (dataurl) => {
        var arr = dataurl.split(","), mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n)
        while(n--){
            u8arr[n] = bstr.charCodeAt(n)
        }
        return new Blob([u8arr], {type:mime})
    }

    handleDownloadCroppedImage = (croppedImage) => {
        this.props.onImageDownloaded()
        let link = document.createElement("a")
        document.body.appendChild(link)
        const blob = this.dataURLtoBlob(croppedImage.filePreviewUrl)
        const objurl = URL.createObjectURL(blob)
        link.download = "helloWorld.png"
        link.href = objurl
        link.onclick = () => {
            // revokeObjectURL needs a delay to work properly
            var that = this
            setTimeout(function() { window.URL.revokeObjectURL(that.href) }, 1500)
        }
        link.click()
        link.remove()
    }

    componentDidUpdate = () => {
        if(this.props.scrollToImageThumbnailsDownload) {
            window.scrollTo({top: document.getElementById("ImageThumbnailsDownloadPanelBodyId").getBoundingClientRect().top, behavior: "smooth"})
            this.props.onScrolledToImageThumbnailsDownload()
        }
    }

    shouldComponentUpdate = (nextProps) => {
        return this.props.croppedImages && nextProps.croppedImages && this.props.croppedImages.length !== nextProps.croppedImages.length
    }

    render() {

        let croppedImagesPanels = this.props.croppedImages.map( (croppedImage, index) => 
            <Col xs={6} md={3} key={`croppedPanel-${croppedImage.imageMd5}-${index}`}>
                <Panel >
                    <Panel.Heading>
                        <Button
                            bsStyle="success"
                            onClick={() => this.handleDownloadCroppedImage(croppedImage)} >
                            Download <Glyphicon glyph="download-alt" 
                                onClick={() => this.handleDownloadCroppedImage(croppedImage)}
                                className={"action-pointer"}
                            />
                        </Button>
                    </Panel.Heading>
                    <Panel.Body>
                        <Image src={croppedImage.filePreviewUrl} thumbnail />
                    </Panel.Body>
                </Panel>
            </Col>
        )

        return (
            <Panel>
                <Panel.Body id={"ImageThumbnailsDownloadPanelBodyId"}>
                    <p>Your crops</p>
                    <Row>
                        {croppedImagesPanels}
                    </Row>
                </Panel.Body>
            </Panel>
        )
    }
}

export default ImageThumbnailsDownload


// WEBPACK FOOTER //
// ./src/components/ImageThumbnailsDownload.jsx